var option_default = {
  "option": "Cdh-X",
  "user_choice": "RZvCj",
  "check": "VGdJc",
  "image": "AlWbM",
  "input": "LzInx",
  "title": "XZUKF",
  "centered": "czy3w",
  "with_result": "T4W94",
  "list": "_1-T4v",
  "with_image": "-R61G",
  "progress": "pyxHR",
  "progress_value": "zF2Vo",
  "label": "XoOKD",
  "cta": "nYcj1",
  "adornment_icon": "TWoAd",
  "remove": "_5QeA4",
  "removeButton": "O-h6R",
  "removeButtonIcon": "_06tpY",
  "overlay": "PgSG7",
  "shown": "mLa-d",
  "dark": "iY7J1",
  "spinner": "GWBgc",
  "spin": "vJmNK"
};
export {
  option_default as default
};
//# sourceMappingURL=option-scss.js.map
